module.exports = __webpack_public_path__ + "static/media/ios-wifi.85d94959.svg";